import React, { useContext, useRef } from "react";
import { Printer } from "lucide-react";
import { useReactToPrint } from "react-to-print";
import DelgroProgressBar from "../../generals/DelgroProgressBar";
import { formatCustomDate, formatCustomDateWithoutTime } from "../../helpers/formatCustomDate";
import { IoPrintSharp } from "react-icons/io5";
import { FaTrash } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { IoAdd } from "react-icons/io5";
import { Dropdown } from "react-bootstrap";




const ProductionDetails = ({ productionList, prodDetails, modifyProduction,deleteProduction,
  onAddNewProduction, processItemSetup, singleActionPerform, actionData
 }) => {
  const componentRef = useRef();
 



  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Production_Details_${prodDetails?.production_item_sku || "document"}`,
    pageStyle: `
      @page {
        size: A4;
        margin: 20mm;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
        }
        .no-print {
          display: none;
        }
      }
    `,
  });


  console.log('prodDetails ', prodDetails);



  return (
    <div className="flex-1 p-6 overflow-y-auto h-screen">
      <div className="m-4">
        {!prodDetails?.production_item_sku && <DelgroProgressBar />}
      </div>

      {/* Top Bar */}
      <div className="flex justify-between items-center mb-4 mt-4">
        <div>
          <h2 className="text-2xl font-semibold">{prodDetails?.production_item_name}</h2>
          <p className="text-sm text-gray-500">SKU: {prodDetails?.production_item_sku || "-"}</p>
        </div>

        {/* Action */}
         {actionData?.length > 0 && (
                                <Dropdown>
                                  <Dropdown.Toggle className="text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md px-4 py-2" id="dropdown-basic">
                                    ACTION
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="mt-1 shadow-lg border border-gray-200 rounded-md bg-white">
                                    {actionData?.map((option, i) => (
                                      <Dropdown.Item className="hover:bg-gray-100" key={i} onClick={() => singleActionPerform(option)}>
                                        <div className="text-sm text-gray-700 py-2 px-4">{option?.status_name}</div>
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              )}
        {/* Action end */}

        <div className="flex items-center space-x-2 no-print">
          {/* Print Button */}
          <button
            onClick={handlePrint}
            className="p-2 border rounded-xl hover:bg-gray-100"
            title="Print Production Details"
          >
            <IoPrintSharp className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
          </button>
         
          <button onClick={modifyProduction}
            className="p-2 border rounded-xl hover:bg-gray-100"
            title="Print Production Details"
          >
       <FaEdit className="h-[23px] w-[23px] flex-shrink-0 text-blue-600" />
          </button>
         
          {/* Action Buttons */}
          <button onClick={processItemSetup} className="px-4 py-2 bg-blue-500 text-white rounded-xl hover:bg-blue-600">
             Setup
          </button>
        
         
          <button onClick={onAddNewProduction}
            className="p-2 border rounded-xl hover:bg-red-100"
            title="Add new Production"
          >
            <IoAdd  className="h-[23px] w-[23px] flex-shrink-0 text-green-600" />
          </button>

          <button onClick={deleteProduction}
            className="p-2 border rounded-xl hover:bg-red-100"
            title="delete production"
          >
            <FaTrash className="h-[23px] w-[23px] flex-shrink-0 text-red-600" />
          </button>
        </div>
      </div>

      {/* Printable Content */}
      <div ref={componentRef} className="bg-white rounded-xl shadow p-6">
        {/* Meta Info */}
        <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
          <div>
            <p className="font-semibold">Ref No:</p>
            <p>{prodDetails?.ref_no}</p>
          </div>
          <div>
            <p className="font-semibold">Production Date:</p>
            <p>{formatCustomDateWithoutTime(prodDetails?.production_date)}</p>
          </div>
          <div>
            <p className="font-semibold">Created Date:</p>
            <p>{formatCustomDateWithoutTime(prodDetails?.encoded_date)}</p>
          </div>
          <div>
            <p className="font-semibold">Warehouse:</p>
            <p>{prodDetails?.warehouse_name}</p>
          </div>
          <div>
            <p className="font-semibold">Created Officer:</p>
            <p>{prodDetails?.encoded_by_name || "-"}</p>
          </div>
          <div>
            <p className="font-semibold">Remark:</p>
            <p>{prodDetails?.production_remark || "-"}</p>
          </div>
        </div>

        {/* Approved + Quantity */}
        <div className="flex items-center justify-between mb-4">
          <p className="text-green-600 border-2 p-2 font-bold text-lg">{prodDetails?.status_name}</p>
          <p className="font-bold text-lg">
            Quantity: <span className="text-blue-600">{prodDetails?.production_quantity || 0}</span>
          </p>
        </div>

        {/* Table */}
        <table className="w-full text-md border">
          <thead className="bg-gray-100">
            <tr>
              <th className="border p-2">ID</th>
              <th className="border p-2">Name</th>
              <th className="border p-2">SKU</th>
              <th className="border p-2">Category</th>
              <th className="border p-2">Qty/Unit</th>
              <th className="border p-2">Req. Qty</th>
              <th className="border p-2">Extra Qty</th>
            </tr>
          </thead>
          <tbody>
            {productionList?.map((product, idx) => (
              <tr key={idx} className="hover:bg-gray-50">
                <td className="border p-2">{product?.item_id}</td>
                <td className="border p-2">{product?.item_name}</td>
                <td className="border p-2">{product?.item_sku}</td>
                <td className="border p-2">{product?.item_category_name}</td>
                <td className="border p-2">{product?.setup_quantity_per_unit}</td>
                <td className="border p-2">{product?.required_quantity}</td>
                <td className="border p-2">{product?.extra_quantity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductionDetails;